import { Confetti } from "../scenes/Confetti";
import { GameVars } from "../GameVars";
import { GameConstants } from "../GameConstants";
import { Hooligan } from "./Hooligan";

    export class CelebrationContainer extends Phaser.Group {

        private race: number;
        private shirtColor: number;
        private scoreLabelGroup: Phaser.Group;
        private rays: Phaser.Image;
        private victoryImage: Phaser.Image;
        private confetti: Confetti;

        constructor( game: Phaser.Game) {

            super( game, null, "celebration-container", false);

            this.confetti = null;

            const teamData: TeamData = GameVars.getPlayerData();

            this.race = teamData.race;

            this.shirtColor = parseInt(teamData.shirt_color.slice(1), 16);

            this.composeCelebration();

            this.composeScoreLabel();

            this.y = 200; // era 200
            
            this.game.add.tween(this)
                .to ({y: 0}, 750, Phaser.Easing.Cubic.Out, true, 500)
                .onComplete.add(function(): void {

                    if (GameVars.matchType === GameConstants.FINAL_MATCH) {
                        this.showConfetti();
                    }
                    
                    this.showReporter();
                    this.activateScoreLabel();
                }, this);
        }

        public update(): void {

            if (this.confetti) {
                this.confetti.update();
            }
        }

        private showConfetti(): void {
            
            this.confetti = new Confetti(this.game);
            this.add(this.confetti.backgroundConfettiContainer);
            this.add(this.confetti.foregroundConfettiContainer);
            this.confetti.activate();
        }

        private composeCelebration(): void {

            let hooligan_dy: number;

            if (GameVars.aspectRatio < 1.45) {
                hooligan_dy = -20;
            } else {
                hooligan_dy = 0;
            }

            let hooligan = new Hooligan(this.game, 75, 970 + hooligan_dy, Hooligan.MALE_BOLD, this.shirtColor, this.race, true);
            this.add(hooligan);

            hooligan = new Hooligan(this.game, 320, 970 + hooligan_dy, Hooligan.MALE_WITH_HAIR, this.shirtColor, this.race, true, true);
            this.add(hooligan);

            hooligan = new Hooligan(this.game, 390, 970 + hooligan_dy, Hooligan.FEMALE, this.shirtColor, this.race, true, true);
            this.add(hooligan);

            hooligan = new Hooligan(this.game, 410, 970 + hooligan_dy, Hooligan.MALE_WITH_HAIR, this.shirtColor, this.race, true);
            this.add(hooligan);

            hooligan = new Hooligan(this.game, 590, 970 + hooligan_dy, Hooligan.MALE_WITH_HAIR, this.shirtColor, this.race, true);
            this.add(hooligan);

            hooligan = new Hooligan(this.game, 700, 970 + hooligan_dy, Hooligan.MALE_BOLD, this.shirtColor, this.race, true);
            this.add(hooligan);

            const semiTransparentLayer = new Phaser.Sprite(this.game, 0, -200, this.game.cache.getBitmapData("black_square"));
            semiTransparentLayer.alpha = .25;
            semiTransparentLayer.scale.setTo(12, 20);
            this.add(semiTransparentLayer);

            hooligan = new Hooligan(this.game, 90, 945 + hooligan_dy, Hooligan.MALE_BOLD, this.shirtColor, this.race, false, true);
            this.add(hooligan);

            hooligan = new Hooligan(this.game, 100, 945 + hooligan_dy, Hooligan.MALE_WITH_HAIR, this.shirtColor, this.race);
            this.add(hooligan);

            hooligan = new Hooligan(this.game, 300, 945 + hooligan_dy, Hooligan.MALE_WITH_HAIR, this.shirtColor, this.race);
            this.add(hooligan);

            hooligan = new Hooligan(this.game, 480, 945 + hooligan_dy, Hooligan.FEMALE, this.shirtColor, this.race);
            this.add(hooligan);

            hooligan = new Hooligan(this.game, 640, 945 + hooligan_dy, Hooligan.MALE_BOLD, this.shirtColor, this.race);
            this.add(hooligan);
        }

        private composeScoreLabel(): void {

            this.scoreLabelGroup = new Phaser.Group(this.game);
            this.scoreLabelGroup.visible = false;
            this.add( this.scoreLabelGroup );

            const raysContainer = new Phaser.Group(this.game);
            raysContainer.x = GameConstants.GAME_WIDTH / 2;
            raysContainer.y = 400;
            raysContainer.scale.y = GameVars.scaleY;
            this.scoreLabelGroup.add(raysContainer); 

            this.rays = new Phaser.Image( this.game, 0, 0, "texture_atlas_1", "rays");
            this.rays.anchor.setTo(.5);
            this.rays.scale.setTo(2.5);
            this.rays.alpha = .8;
            raysContainer.add(this.rays);

            const scoreLabel = new Phaser.Text(this.game, 384, 340, GameVars.playerGoals + "-" + GameVars.adversaryGoals, {font: "125px futura-bold", fill: "#2BB740"});
            scoreLabel.anchor.x = .5;
            scoreLabel.setShadow(4, 4, "rgba(0,0,0,1)", 0);
            scoreLabel.scale.y = GameVars.scaleY;
            this.scoreLabelGroup.add( scoreLabel);

            this.victoryImage = new Phaser.Image( this.game, GameConstants.GAME_WIDTH / 2, 515, "texture_atlas_5", "victory-celebration");
            this.victoryImage.anchor.setTo(.5);
            this.scoreLabelGroup.add(this.victoryImage);
        }

        private activateScoreLabel(): void {

            this.game.add.tween(this.rays)
                .to({angle: 360}, 6000,  Phaser.Easing.Linear.None, true)
                .loop();

            this.scoreLabelGroup.visible = true;
        }

        private showReporter(): void {

            const reporter = new Phaser.Image( this.game, GameConstants.GAME_WIDTH / 2, 1200, "texture_atlas_5", "speaker_celebration");
            reporter.anchor.setTo(.5, 1);
            reporter.scale.set(1, GameVars.scaleY);
            this.add(reporter);

            this.game.add.tween(reporter)
                .to({y: GameConstants.GAME_HEIGHT}, 500,  Phaser.Easing.Elastic.Out, true)
                .onComplete.add(function(): void {
                    const pulseTween = this.game.add.tween(reporter.scale);
                    pulseTween.to ({x: 1.025, y: .975 * GameVars.scaleY}, 250, Phaser.Easing.Linear.None, false);
                    pulseTween.delay (50);
                    pulseTween.to ({x: .975, y: 1.025 * GameVars.scaleY}, 500, Phaser.Easing.Elastic.Out);
                    pulseTween.loop();
                    pulseTween.start();
                }, this);

            const pulseTween = this.game.add.tween(this.victoryImage.scale);
            pulseTween.to ({x: 1.05, y: .8 * GameVars.scaleY}, 300, Phaser.Easing.Linear.None, false);
            pulseTween.delay (50);
            pulseTween.to ({x: .95, y: 1.05 * GameVars.scaleY}, 700, Phaser.Easing.Elastic.Out);
            pulseTween.loop();
            pulseTween.start();
        }
    }
